/**
 * @file 打车跳转函数相关
 * @author lishangming
 */

import com from '@/common/utils/com.js';
import url from '@/pages/global-newyear-yy/url';

// 跳转打车 API 基础部分
const srcFrom = 'OM-Labourday';
const baseHead = 'baidumap://map/cost_share?url=';
const basePath = `&popRoot=no&mode=NORMAL_MAP_MODE&hideshare=1&src_from=${srcFrom}`;
const transparent = '&popRoot=no&transparentWeb=0&navigationStatus=2&hiddenBackBtn=0&hiddenTitle=1';
const isNative = com.plat.isNative;


/**
 * 跳转至打车内部页面 端外：调起端跳转至本活动页面 端内：直接跳转至指定页面
 *
 * @param {string} openAPI 跳转页面目标地址
 */
export const jumpDachePage = openAPI => {
    let str = 'http://cjh-fe-zhuqijia-2020.bcc-bdbl.baidu.com:8085/static/dache-labourday/dache-labourday.html';
    // 默认跳透明壳
    /* eslint-disable */
    let openapi =
        'baidumap://map/cost_share?url=' +
        encodeURIComponent(str) +
        '&transparentWeb=0&navigationStatus=2&hiddenBackBtn=0&hiddenTitle=1';
    /* eslint-enable */
    if (!window.yymap.nativeAppAdapter.plat.isNative) {
        // 非端内打开
        let fallbackUrl = 'https://map.baidu.com/zt/client/index/?down=iphone&fr=OM-Newyear';
        if (window.yymap.nativeAppAdapter.plat.isWeixin || window.yymap.nativeAppAdapter.plat.isWeibo) {
            // android微信需要使用蒙层，不能调用openClient，否则会调到应用宝
            window.yymap.nativeAppAdapter.openLayer();
            if (!window.yymap.nativeAppAdapter.plat.isAndroid) {
                window.yymap.nativeAppAdapter.universalLinks(fallbackUrl, openapi);
            }
        }
        else {
            if (document.location.href.indexOf('fr=wangpan') > 0) {
                // 网盘用baidumap协议，universal link无法调起
                window.location = openapi;
            }
            else {
                if (!window.yymap.nativeAppAdapter.plat.isAndroid) {
                    window.yymap.nativeAppAdapter.universalLinks(fallbackUrl, openapi);
                }
                else {
                    window.yy.naa.openClient({
                        openapi: openapi,
                        iosTime: 3000
                    });
                }
            }
        }
        return;
    }
    // 端内直接跳转已经处理过的 openAPI
    location.href = openAPI;
    return;
};

/**
 * 跳转打车优惠页面
 * @param {Number} type - 0 跳转默认优惠券tab 1 跳转打车金 tab
 */
export const jumpCoupon = type => {
    // 跳转H5的链接
    let url = 'https://yongche.baidu.com/#/couponList';
    // 线下优惠券地址 方便测试;
    // let url = 'http://duanyuwei-2020-001.bcc-bdbl.baidu.com:8091/#/couponList';
    if (type) {
        url += '?toIntergral=' + type;
    }
    const openAPI = baseHead + encodeURIComponent(url) + basePath;
    if (isNative) {
        jumpDachePage(openAPI);
        return;
    }
    location.href = url;
};

/**
 * 跳转其他tab活动页面
 * @param {String} openAPI 跳转其他活动的地址
 */
export const jumpTab = openAPI => {
    jumpDachePage(openAPI);
    return;
};

/**
 * 跳转购买商品页面
 */
export const jumpVouchers = index => {
    // 跳转H5的链接
    let goodID = index === 0 ? 80 : 73;
    const url = 'https://yongche.baidu.com/vouchers.html#/detail?goods_id=' + goodID;
    const openAPI = baseHead + encodeURIComponent(url) + basePath;
    if (isNative) {
        jumpDachePage(openAPI);
        return;
    }
    location.href = url;
};

/**
 * 跳转打车首页
 */
export const jumpDacheMain = () => {
    /* eslint-disable */
    const url =
        `baidumap://map/component?popRoot=no&resetRoot=no&needLocation=yes&needCloud=yes&comName=rentcar&target=rentcar_entrance&mode=MAP_MODE&param=%7B%22src_from%22%3A%22${srcFrom}%22%7D`;
    /* eslint-enable */
    jumpDachePage(url);
};

/**
 * 跳转打车行程分享活动
 */
export const jumpDacheShare = () => {
    // 跳转H5的链接
    const url = 'https://opn.baidu.com/map/2019/zhifufenxiang?tpltype=1';
    const openAPI = baseHead + encodeURIComponent(url) + basePath;
    jumpDachePage(openAPI);
};

/**
 * 跳转百度活动
 */
export const jumpBaidu = () => {
    // 跳转H5的链接
    const openAPI = 'baidumap://map/mnp?src=sug&url=mapmnp%3A%2F%2Fswan%2FGWbWxW4YYYv6valCeNxFhH3oKglumMU1%2Fpages%2Findex%2Findex%3Fidfrom%3Dditu';
    jumpDachePage(openAPI);
};

/**
 * 开心收下时 清空页面参数重新加载
 */
export const replaceReload = () => {
    // 获取当前地址
    const url = location.protocol + '//' + location.host + location.pathname;
    // 拼接透明壳
    const openAPI = baseHead + encodeURIComponent(url)
        + '&transparentWeb=0&navigationStatus=2&hiddenBackBtn=0&hiddenTitle=1';
    location.replace(openAPI);
};

